<template>
    <div class="user-deposit" v-if="userInfo">
    <el-menu mode="horizontal" :default-active="activeTab" @select="onSelect">
        <el-menu-item index="/dashboard/payment">My Redeems</el-menu-item>
        <el-menu-item index="/dashboard/payment/my-dispenser">My Dispenser</el-menu-item>
        <el-menu-item index="/dashboard/payment/my-bill">My Bills</el-menu-item>
        <el-menu-item index="/dashboard/payment/my-invoice">My Invoice</el-menu-item>
    </el-menu>
    
    <router-view></router-view>
        <!-- <DispenserList :deposit_request_id="dispenser_id" :authenticate_id="userInfo.authenticate_id" :admin_view="false"/> -->
    </div>
</template>

<script>
// @ is an alias to /src
// import DispenserList from "@/components/DispenserList";
import { mapState } from "vuex";

export default {
    name: "UserDispenser",
    components: {
        // DispenserList,
    },
    props:{
        dispenser_id: {type: String, default: null}
    },
    data() {
        return {
            // activeTab: "MY_REDEEM",
        };
    },
    mounted() {
        let ctrl = this;
        if(!ctrl.userInfo) {
            ctrl.$alert('Please login with your account', 'Login required', {
                confirmButtonText: 'OK',
                callback: () => {
                    ctrl.$router.push({ path: "/", replace: true });
                }
            });
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.userInfo
        }),
        activeTab() {
            return this.$router.currentRoute.path;
        }
    },
    methods: {
        onSelect(path) {
            console.log(path, this.$router.currentRoute.path);
            this.$router.push({ path });
        }
    },
    watch: {
        userInfo(userInfo = null) {
            let ctrl = this;
            if(!userInfo) {
                ctrl.$alert('Please login with your account', 'Login required', {
                    confirmButtonText: 'OK',
                    callback: () => {
                        ctrl.$router.push({ path: "/" });
                    }
                });
            }
        }
    }
};
</script>
<style scoped>
</style>